module.exports = __webpack_public_path__ + "media/images/flags/nu-61f17ae212e1f1f4e4db303caf705623.svg";